export default string => string.replace(/(?:^|\s)\S/g, c => c.toUpperCase());
